import {
  type ClaimReceiptResponse,
  type FetchReceiptResponse,
  type Guard,
} from '../receipt.machine.types';

// ─── Fetch receipt ───────────────────────────────────────────────────────────

const checkIfReceipt: Guard<FetchReceiptResponse> = (_args, params) => {
  return params.result === 'Receipt';
};

const checkIfExpiredReceipt: Guard<FetchReceiptResponse> = (_args, params) => {
  return params.result === 'ExpiredReceipt';
};

const checkIfReceiptNotFound: Guard<FetchReceiptResponse> = (_args, params) => {
  return params.result === 'ReceiptNotFound';
};

const checkIfReceiptAlreadyClaimed: Guard<FetchReceiptResponse> = (_args, params) => {
  return params.result === 'ReceiptAlreadyClaimed';
};

const checkIfReceiptAlreadyClaimedByUser: Guard<FetchReceiptResponse> = (_args, params) => {
  if (params.result !== 'Receipt') return false;

  const receipt = params.receipt;

  return receipt?.__typename === 'Receipt' && receipt.isClaimed === true;
};

// ─── Claim receipt ───────────────────────────────────────────────────────────

const checkIfClaimSucceeded: Guard<ClaimReceiptResponse> = (_args, params) => {
  return params.result === 'IdentifyAndClaimInStoreOrderSuccess';
};

const checkIfTimeRestrictionError: Guard<ClaimReceiptResponse> = (_args, params) => {
  return params.result === 'TimeRestrictionError';
};

const checkIfReceiptAlreadyClaimedError: Guard<ClaimReceiptResponse> = (_args, params) => {
  return params.result === 'ReceiptAlreadyClaimedError';
};

const checkIfTransactionNotFoundError: Guard<ClaimReceiptResponse> = (_args, params) => {
  return params.result === 'TransactionNotFoundError';
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfClaimSucceeded,
  checkIfTimeRestrictionError,
  checkIfReceiptAlreadyClaimedError,
  checkIfTransactionNotFoundError,
  checkIfReceipt,
  checkIfExpiredReceipt,
  checkIfReceiptAlreadyClaimed,
  checkIfReceiptAlreadyClaimedByUser,
  checkIfReceiptNotFound,
};
